import { render } from "./ProjectTeamExchange.vue?vue&type=template&id=bde31c5e&scoped=true"
import script from "./ProjectTeamExchange.vue?vue&type=script&lang=js"
export * from "./ProjectTeamExchange.vue?vue&type=script&lang=js"

import "./ProjectTeamExchange.vue?vue&type=style&index=0&id=bde31c5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bde31c5e"]])

export default __exports__